<template>
  <section>
    <qx-img-dialog ref="imgDialog" />
    <div class="detail-item-box" :class="{'horizontal': detailItemHorizontal}">
      <div class="detail-item-vertical" v-for="(item, index) in detailItemList" :key="index">
        <span class="detail-item-label">{{item.label}}：</span>
        <template v-if="item.type === 'img'">
          <span class="detail-item-value">

             <span
                 class="detial-item-img"
                 v-if="(orderDetail.base && orderDetail.base[propName] && orderDetail.base[propName][item.value] && typeof orderDetail.base[propName][item.value] ==='object') "
                 style="display:inline;"
             >
               <span v-for="(url,index) in getFileUrls(orderDetail.base[propName][item.value])" :key="index">
                  <img
                      class="cur"
                      :src="url"
                      v-if="!isPdfUrl(url)"
                      @click="previewImg(url, getImageUrls(orderDetail.base[propName][item.value]))"
                  />
                 <a class="cur" v-else :href="url" target="_blank">
                   <img class="cur" style="cursor:pointer" src="~images/pdf-icon.png" />
                 </a>
               </span>

            </span>
             <span
                class="detial-item-img"
                v-else-if="(orderDetail.base && orderDetail.base[propName] && orderDetail.base[propName][item.value] && typeof orderDetail.base[propName][item.value] ==='string') "
             >
               <img
                 class="cur"
                 :src="orderDetail.base[propName][item.value]"
                 v-if="!isPdfUrl(orderDetail.base[propName][item.value])"
                 @click="previewImg(orderDetail.base[propName][item.value], getImageUrls(orderDetail.base[propName][item.value]))"
               />
               <a
                   class="cur"
                   v-if="isPdfUrl(orderDetail.base[propName][item.value])"
                   :href="orderDetail.base[propName][item.value]"
                   target="_blank"
               >
                    <img style="cursor:pointer" src="~images/pdf-icon.png" />
                  </a>
             </span>
            <span v-else>未上传</span>
          </span>
        </template>
        <template v-else>
          <span
            class="detail-item-value"
          >{{orderDetail && orderDetail.base && orderDetail.base[propName] && (orderDetail.base[propName][item.value] || '--')}}</span>
          <span
            class="error"
            v-if="(orderDetail && orderDetail.base && orderDetail.baseVer) && (orderDetail.baseVer[propName][item.value]) &&
            (orderDetail.base[propName][item.value] !== orderDetail.baseVer[propName][item.value])"
          >
            <span class="label">修改为：</span>
            {{orderDetail.baseVer[propName][item.value]}}
          </span>
        </template>

        <div v-if="isOrderPaymentWay && item.label === '预支/借支款金额'" class="profitBox">
          <span class="equal">=</span>
          <div class="profitRow">
            <el-row>
              <el-col :span="8" class="th_1"><span class="grid-content bg-purple">&nbsp;</span></el-col>
              <el-col :span="8" class="th_1"><span class="grid-content bg-purple-light">预估支出</span></el-col>
              <el-col :span="8" class="th_1"><span class="grid-content bg-purple">实际支出</span></el-col>
            </el-row>
            <el-row v-for="(moneyType, moneyIndex) in moneyTypeList" :key="moneyIndex" style="margin-top:5px">
              <el-col :span="8" class="td_1">
                <el-popover
                  placement="top-start"
                  title=""
                  width="200"
                  trigger="hover"
                  :content="moneyType.moneyTypeName">
                  <span slot="reference" v-if="moneyType.moneyTypeName && moneyType.moneyTypeName.length > 10">
                    <span>{{moneyType.moneyTypeName}}</span>
                  </span>
                </el-popover>
                <span>{{moneyType.moneyTypeName}}</span>
                <span>{{'：'}}</span>
              </el-col>
              <el-col :span="8" class="td_2"><div class="grid-content bg-purple-light">{{ moneyType.moneyTypeValueDouble }}</div></el-col>
              <el-col :span="8" class="td_2">
                <div class="grid-content bg-purple">{{ moneyType.auditingStatus === 0 ? moneyType.moneyValuePayDouble : '--' }}</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-popover placement="right" width="400" trigger="hover" v-if="item.label==='预估利润'" popper-class="popoverBackB">
          <div>预估利润=预估收入-主驾基本服务费-副驾基本服务费-预估支出总和</div>
          <div>预估收入：运营管理-->订单录入-->收入信息-->预估收入</div>
          <div>预估支出总和：即预支/借支款，也是出车时各项出车明细总和</div>
          <i class="el-icon-question warning" slot="reference"></i>
        </el-popover>
        <el-popover placement="right" width="450" trigger="hover" v-if="item.label==='实际利润'" popper-class="popoverBackB">
          <div>实际利润=核销金额-主驾基本服务费-副驾基本服务费-实际支出总和</div>
          <div>确认收入：客户应收-->应收订单-->核销金额</div>
          <div>实际的收入应是客户已付款核销后的订单金额，方可算入到实际收入中</div>
          <i class="el-icon-question warning" slot="reference"></i>
        </el-popover>
      </div>
    </div>
  </section>
</template>

<script>
import imagePreview from '@qx/components/imagePreview';

const { buildImagePreviewState, getImageUrl, isPdfUrl } = imagePreview;

export default {
  props: {
    detailItemHorizontal: {
      type: Boolean,
      default: false,
    },
    detailItemList: {
      type: Array,
      default: () => [],
    },
    propName: {
      type: String,
      default: '',
    },
    orderDetail: {
      type: Object,
      default: () => ({}),
    },
    moneyTypeList: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      isVerity: '',
    };
  },
  computed: {
    isOrderPaymentWay () {
      const base = this.orderDetail && this.orderDetail.base;
      return !!base && (base.paymentWayName === '订单模式' || Number(base.paymentWay) === 4);
    },
  },
  methods: {
    isPdfUrl,
    getFileUrls (value) {
      const values = Array.isArray(value) ? value : [value];
      return values.map(getImageUrl).filter((url) => url);
    },
    getImageUrls (value) {
      const values = Array.isArray(value) ? value : [value];
      return buildImagePreviewState('', values).urls;
    },
    previewImg (url, urls) {
      this.$refs.imgDialog.show(url, urls);
    },
  },
  mounted () {
    this.isVerity = this.$route.query.isVerity;
  },
};
</script>

<style lang="scss" scoped>
.detail-item-box {
  margin: 8px 0;
  &.horizontal {
    .error {
      display: block;
      .label {
        display: inline-block;
        width: 100px;
      }
    }
  }
  .detail-item-vertical {
    line-height: 2.2;
    .detail-item-label {
      min-width: 100px;
      display: inline-block;
      position: relative;
    }
    .detail-item-value {
      margin-right: 8px;
      .detial-item-img {
        display: inline-block;
        min-height: 40px;
        padding: 8px 8px 8px 0;
        img {
          width: 80px;
          height: 80px;
          margin-right: 16px;
        }
      }
    }

    .profitBox {
      width: 320px;
      display: inline-block;
      background: #FAFAFA;
      border: 1px solid #DCDFE6;
      margin-left: 25px;

      .td_1 {
        height: 30px;
        line-height: 30px;
        text-align: right;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-left: 15px;
      }

      .th_1 {
        border-bottom: 1px solid #DCDFE6;
        text-align: center;
      }

      .td_2 {
        text-align: center;
      }

      .equal {
        position: relative;
        top: 0;
        left: -20px;
      }
    }

  }

}
</style>

<style lang="scss">
.el-popover.popoverBackB{
  background: #FFFF00 !important;
}
</style>
